import { combine, createStore } from 'effector';
import { errorHandlerFx } from '../../../../model/errorHandler';
import { createEffectJWT } from '../../../../model/JWT';
import { getList, RGetList } from '../../../../apiRPC/account';
import { $board } from '../../../model/board';
import { $account } from '../../../../model/account';
import { $accounts } from '../../../model/card/accounts';

export const accountGetListFX = errorHandlerFx(createEffectJWT(getList));

export const $accountList = createStore<RGetList['rows']|null>(null)
  .on(accountGetListFX.doneData, (_, payload) => payload.rows)

export const  $accountsForAccess = combine({accountList:$accountList,board:$board,account:$account},({accountList,board,account})=>{
  if(!accountList) return null;
  if(!board) return accountList;
  const filtered = accountList.filter((item) => item.uuid !== board.owner && item.uuid !== account?.uuid);
  return filtered;
})

export const $currentAccount = combine({accountsForAccess:$accountsForAccess,accounts:$accounts},({accountsForAccess,accounts})=>{
  if(!accounts) return  [];
  if(!accountsForAccess) return [];
  const accountsForAccessSet = new Set(accountsForAccess.map(item=>item.uuid));
  const filtered = accounts.filter(item=>accountsForAccessSet.has(item.uuid))
  return filtered;
})

export const $accountGetListFXPending =combine({accountList:$accountList,pending:accountGetListFX.pending},({accountList,pending})=>{
  if(accountList) return false;
  return pending
})